// react
import { useCallback } from 'react';

// hooks
import { useCareProfile } from 'hooks';
import { useGoBack } from 'hooks/useGoBack';

// store
import { useSelector, dispatch } from 'store';
import { getAccount } from 'store/slices/iamSlice';
import { newToast } from 'store/slices/uiSlice';

// router
import { ROUTES } from 'router';

// components
import { FormIntroPage } from '@karehero/llama/pwa/pages/FormIntroPage/FormIntroPage';
import { CareProfileCategoryID } from '@karehero/models';

/**
 * FinancialStatusStart is the page displayed for starting the financial status process.
 */
export const FinancialStatusStart = () => {
  // hooks
  const goBack = useGoBack();
  const { handleStart, careProfileID } = useCareProfile({
    categoryID: CareProfileCategoryID.FinancialStatus,
  });
  const account = useSelector(getAccount);
  const isAdminWithoutCareProfile =
    account?.accountRole?.name === 'KareHero Administrator' && !careProfileID;

  const onStart = useCallback(() => {
    if (isAdminWithoutCareProfile) {
      dispatch(
        newToast({
          title: 'Please select a care circle first',
          variant: 'warning',
          action: {
            label: 'Select care circle',
            href: ROUTES.ADMIN_CARE_CIRCLE_MANAGE,
          },
        }),
      );
      return;
    }
    handleStart();
  }, [isAdminWithoutCareProfile, handleStart]);

  return (
    <FormIntroPage
      onBack={goBack}
      title='Financial Status'
      description='Understanding your financial situation helps us identify funding options and benefits you may be entitled to, so you can make informed decisions about care.'
      items={[
        {
          icon: 'file-contract',
          text: 'Answer financial questions about the person requiring care.',
        },
        {
          icon: 'check-circle',
          text: 'Our experts will review and calculate your bespoke funding options.',
        },
        {
          icon: 'home',
          text: "We'll send you a My Funding Guide and help you apply for funding/benefits, if relevant.",
        },
      ]}
      infoText="We've helped thousands of families claim funding they didn't realise they were eligible for."
      onStart={onStart}
      muxPlaybackId='qHuNYnlRfBz6VfjIBaQNqQLH02FSFJKPVnp3MSG01H01QU'
      muxThumbnailTime={0}
    />
  );
};

FinancialStatusStart.displayName = 'FinancialStatusStart';
export default FinancialStatusStart;
